
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JSoWM", function(module, exports) {
$parcel$export(module.exports, "FooterLabels", () => (parcelRequire("1xzIe")).FooterLabels);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1xzIe = parcelRequire("1xzIe");


});

parcelRegister("hysf6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $jmjWc = parcelRequire("jmjWc");


const $4119a6166d969e95$var$DetailsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TmpiW",
    name: "DetailsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("42SEj"))).DetailsPanelHeaderIcon
});

const $4119a6166d969e95$var$DetailsPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WdQRW",
    name: "DetailsPanelBody",
    loader: async ()=>(await (parcelRequire("do7Hb"))).DetailsPanelBody
});
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = (0, $cozmU.useCallback)(({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: $4119a6166d969e95$var$DetailsPanelHeaderIcon,
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: $4119a6166d969e95$var$DetailsPanelBody,
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    }, [
        showObjectSidebar
    ]);
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("42SEj", function(module, exports) {

let $2f21bd807d681431$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f21bd807d681431$var$load("5iVGR"),
    $2f21bd807d681431$var$load("yIsjX"),
    $2f21bd807d681431$var$load("hNY6U"),
    $2f21bd807d681431$var$load("4RQK3"),
    $2f21bd807d681431$var$load("hBTro"),
    $2f21bd807d681431$var$load("6WNyl"),
    $2f21bd807d681431$var$load("c831e"),
    $2f21bd807d681431$var$load("6xy0M"),
    $2f21bd807d681431$var$load("7Y0AX"),
    $2f21bd807d681431$var$load("ezYRV"),
    $2f21bd807d681431$var$load("2xKrc"),
    $2f21bd807d681431$var$load("bSZcP"),
    $2f21bd807d681431$var$load("3XBcy"),
    $2f21bd807d681431$var$load("6e4fH"),
    $2f21bd807d681431$var$load("Wowvf"),
    $2f21bd807d681431$var$load("7EorR"),
    $2f21bd807d681431$var$load("jqoep"),
    $2f21bd807d681431$var$load("9cpj1"),
    $2f21bd807d681431$var$load("i1Rpl"),
    $2f21bd807d681431$var$load("l5Dl9"),
    $2f21bd807d681431$var$load("6zCMk"),
    $2f21bd807d681431$var$load("ckGjo"),
    $2f21bd807d681431$var$load("6wr18"),
    $2f21bd807d681431$var$load("ffEVr"),
    $2f21bd807d681431$var$load("8zlfy")
]).then(()=>parcelRequire('7N9MO'));

});

parcelRegister("do7Hb", function(module, exports) {

let $9bf37c6b34e85328$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9bf37c6b34e85328$var$load("5iVGR"),
    $9bf37c6b34e85328$var$load("yIsjX"),
    $9bf37c6b34e85328$var$load("hNY6U"),
    $9bf37c6b34e85328$var$load("4RQK3"),
    $9bf37c6b34e85328$var$load("hBTro"),
    $9bf37c6b34e85328$var$load("6WNyl"),
    $9bf37c6b34e85328$var$load("c831e"),
    $9bf37c6b34e85328$var$load("6xy0M"),
    $9bf37c6b34e85328$var$load("7Y0AX"),
    $9bf37c6b34e85328$var$load("ezYRV"),
    $9bf37c6b34e85328$var$load("2xKrc"),
    $9bf37c6b34e85328$var$load("bSZcP"),
    $9bf37c6b34e85328$var$load("3XBcy"),
    $9bf37c6b34e85328$var$load("6e4fH"),
    $9bf37c6b34e85328$var$load("Wowvf"),
    $9bf37c6b34e85328$var$load("7EorR"),
    $9bf37c6b34e85328$var$load("jqoep"),
    $9bf37c6b34e85328$var$load("9cpj1"),
    $9bf37c6b34e85328$var$load("i1Rpl"),
    $9bf37c6b34e85328$var$load("l5Dl9"),
    $9bf37c6b34e85328$var$load("6zCMk"),
    $9bf37c6b34e85328$var$load("ckGjo"),
    $9bf37c6b34e85328$var$load("6wr18"),
    $9bf37c6b34e85328$var$load("ffEVr"),
    $9bf37c6b34e85328$var$load("8zlfy")
]).then(()=>parcelRequire('9igqG'));

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("jmPAG"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("jmPAG", function(module, exports) {

let $e198173ab945d389$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e198173ab945d389$var$load("ezYRV"),
    $e198173ab945d389$var$load("6wr18"),
    $e198173ab945d389$var$load("4fYzp"),
    $e198173ab945d389$var$load("ayJxT"),
    $e198173ab945d389$var$load("jigcs"),
    $e198173ab945d389$var$load("ffEVr"),
    $e198173ab945d389$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("jkwMx", function(module, exports) {

var $cqob2 = parcelRequire("cqob2");


var $e9oF4 = parcelRequire("e9oF4");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9HB34 = parcelRequire("9HB34");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $ad7e745e3d59b8c7$export$bb5886bf758160d3 = (0, $e9oF4.default);
const $ad7e745e3d59b8c7$export$ffff3ea8cf53a69e = (0, $cqob2.default);
const $ad7e745e3d59b8c7$var$SETTLED_EMPTY = {
    labels: [],
    loading: false,
    error: undefined
};
const $ad7e745e3d59b8c7$export$1e91156d5765cc4b = (cloudId, contentId)=>cloudId && contentId ? `ari:cloud:confluence:${cloudId}:page/${contentId}` : '';
const $ad7e745e3d59b8c7$export$48837ed000c21cf = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const entityAri = $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId);
    const skip = !(0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') || !cloudId || !contentId;
    // Start loading when active so consumers don't flash empty before the first read.
    const [state, setState] = (0, $cozmU.useState)(()=>skip ? $ad7e745e3d59b8c7$var$SETTLED_EMPTY : {
            labels: [],
            loading: true,
            error: undefined
        });
    const runQuery = (0, $cozmU.useCallback)(()=>{
        if (skip) {
            setState($ad7e745e3d59b8c7$var$SETTLED_EMPTY);
            return ()=>{};
        }
        setState((prev)=>({
                ...prev,
                loading: true,
                error: undefined
            }));
        let cancelled = false;
        const subscription = (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ad7e745e3d59b8c7$export$bb5886bf758160d3, {
            cloudId: cloudId,
            id: entityAri
        }, {
            // Read store-first (warmed by `preloadManagedLabels` during SSR),
            // network otherwise. No `X-Query-Context` header: the field resolves
            // headerless, which is what lets it fold into the batched
            // ContentUnifiedQuery.
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                if (cancelled) return;
                // Gateway types array and elements as nullable; drop nulls.
                setState({
                    labels: (data?.confluence_externalLabels ?? []).filter((label)=>label != null),
                    loading: false,
                    error: undefined
                });
            },
            error: (err)=>{
                if (cancelled) return;
                setState((prev)=>({
                        ...prev,
                        loading: false,
                        error: err instanceof Error ? err : new Error(String(err))
                    }));
            }
        });
        return ()=>{
            cancelled = true;
            subscription.unsubscribe();
        };
    }, [
        skip,
        cloudId,
        entityAri
    ]);
    // `runQuery` returns its cleanup, tearing down the in-flight fetch on unmount/re-run.
    (0, $cozmU.useEffect)(()=>{
        return runQuery();
    }, [
        runQuery
    ]);
    return {
        labels: state.labels,
        loading: state.loading,
        error: state.error,
        refetch: ()=>{
            if (!skip) runQuery();
        }
    };
};
const $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba = (fragmentRef)=>{
    // Native `useFragment` calls `useRelayEnvironment()` even for a null ref, so it
    // throws when no provider is mounted (Apollo mode / Apollo-mode jest tests). The
    // spread only exists when the gate is on, so skip the read entirely when it's off.
    // The gate is session-stable within a render tree, matching `useReadFragmentInterop`.
    const data = (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? // eslint-disable-next-line react-hooks/rules-of-hooks -- gate is session-stable within a render tree, matching useReadFragmentInterop
    (0, $6SsN4.useFragment)($ad7e745e3d59b8c7$export$ffff3ea8cf53a69e, fragmentRef ?? null) : null;
    // Gateway types array and elements as nullable; drop nulls.
    return (data?.confluence_externalLabels ?? []).filter((label)=>label != null);
};
const $ad7e745e3d59b8c7$export$931547829ee50720 = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeExternalLabels = Boolean(cloudId) && Boolean(contentId) && (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint');
    return {
        includeExternalLabels: includeExternalLabels,
        cloudId: includeExternalLabels ? cloudId : '',
        id: includeExternalLabels ? $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId) : ''
    };
};
module.exports["buildExternalLabelsAri"] = $ad7e745e3d59b8c7$export$1e91156d5765cc4b;
module.exports["useExternalLabels"] = $ad7e745e3d59b8c7$export$48837ed000c21cf;
module.exports["useExternalLabelsFragment"] = $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba;
module.exports["useExternalLabelsFragmentVariables"] = $ad7e745e3d59b8c7$export$931547829ee50720;

});

parcelRegister("cqob2", function(module, exports) {
/**
 * @generated SignedSource<<69a1f3de73c3ec1c5c64e3b35cea7a4d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07831018b6e60c32$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ],
    "kind": "Fragment",
    "name": "useExternalLabels_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "Query"
};
$07831018b6e60c32$var$node.hash = "7d28bc802d44490f82047790ad70cb83";
var $07831018b6e60c32$export$2e2bcd8739ae039 = $07831018b6e60c32$var$node;
module.exports["default"] = $07831018b6e60c32$export$2e2bcd8739ae039;

});

parcelRegister("e9oF4", function(module, exports) {
/**
 * @generated SignedSource<<b9754658ef133de839007ab6255673ef>>
 * @relayHash 86987791157c6aeb4f02ade819203bff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290
const $d3d143b69f678795$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "86987791157c6aeb4f02ade819203bff",
            "id": "f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290",
            "metadata": {},
            "name": "useExternalLabelsQuery",
            "operationKind": "query",
            "text": "query useExternalLabelsQuery($cloudId:ID!,$id:ID!){confluence_externalLabels(cloudId:$cloudId,id:$id){id,kind,name}}"
        }
    };
}();
$d3d143b69f678795$var$node.hash = "05a01cd2e9877ac3fd6774883b47072b";
var $d3d143b69f678795$export$2e2bcd8739ae039 = $d3d143b69f678795$var$node;
module.exports["default"] = $d3d143b69f678795$export$2e2bcd8739ae039;

});

parcelRegister("5pMqB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// Stable empty overlay so `getSnapshot` returns a referentially-stable value
// when a content id has no pending optimistic changes (required by
// useSyncExternalStore to avoid render loops).
const $b65ece114130bf2f$var$EMPTY_OVERLAY = {
    applied: [],
    removedIds: []
};
const $b65ece114130bf2f$var$overlaysByContentId = new Map();
const $b65ece114130bf2f$var$listeners = new Set();
function $b65ece114130bf2f$var$emit() {
    for (const listener of $b65ece114130bf2f$var$listeners)listener();
}
function $b65ece114130bf2f$var$subscribe(listener) {
    $b65ece114130bf2f$var$listeners.add(listener);
    return ()=>{
        $b65ece114130bf2f$var$listeners.delete(listener);
    };
}
function $b65ece114130bf2f$var$getOverlay(contentId) {
    return $b65ece114130bf2f$var$overlaysByContentId.get(contentId) ?? $b65ece114130bf2f$var$EMPTY_OVERLAY;
}
function $b65ece114130bf2f$var$setOverlay(contentId, overlay) {
    if (overlay.applied.length === 0 && overlay.removedIds.length === 0) $b65ece114130bf2f$var$overlaysByContentId.delete(contentId);
    else $b65ece114130bf2f$var$overlaysByContentId.set(contentId, overlay);
    $b65ece114130bf2f$var$emit();
}
function $b65ece114130bf2f$export$9b54af9aebcc60dd(contentId, label) {
    if (!contentId || !label.id) return;
    const prev = $b65ece114130bf2f$var$getOverlay(contentId);
    $b65ece114130bf2f$var$setOverlay(contentId, {
        applied: [
            ...prev.applied.filter((l)=>l.id !== label.id),
            label
        ],
        removedIds: prev.removedIds.filter((id)=>id !== label.id)
    });
}
function $b65ece114130bf2f$export$20e81981b62d0763(contentId, labelId) {
    if (!contentId || !labelId) return;
    const prev = $b65ece114130bf2f$var$getOverlay(contentId);
    $b65ece114130bf2f$var$setOverlay(contentId, {
        applied: prev.applied.filter((l)=>l.id !== labelId),
        removedIds: prev.removedIds.includes(labelId) ? prev.removedIds : [
            ...prev.removedIds,
            labelId
        ]
    });
}
function $b65ece114130bf2f$export$3d3b7bba0896e547(contentId, labelId) {
    if (!contentId || !labelId) return;
    const prev = $b65ece114130bf2f$var$getOverlay(contentId);
    $b65ece114130bf2f$var$setOverlay(contentId, {
        applied: prev.applied.filter((l)=>l.id !== labelId),
        removedIds: prev.removedIds
    });
}
function $b65ece114130bf2f$export$4b06ca8750380d71(contentId, labelId) {
    if (!contentId || !labelId) return;
    const prev = $b65ece114130bf2f$var$getOverlay(contentId);
    $b65ece114130bf2f$var$setOverlay(contentId, {
        applied: prev.applied,
        removedIds: prev.removedIds.filter((id)=>id !== labelId)
    });
}
function $b65ece114130bf2f$export$82eebc89860bc67a(contentId, serverIds) {
    if (!contentId) return;
    const prev = $b65ece114130bf2f$var$getOverlay(contentId);
    if (prev === $b65ece114130bf2f$var$EMPTY_OVERLAY) return;
    const applied = prev.applied.filter((l)=>!serverIds.has(l.id));
    const removedIds = prev.removedIds.filter((id)=>serverIds.has(id));
    if (applied.length === prev.applied.length && removedIds.length === prev.removedIds.length) return;
    $b65ece114130bf2f$var$setOverlay(contentId, {
        applied: applied,
        removedIds: removedIds
    });
}
function $b65ece114130bf2f$export$9fac4e0451bfa81d(serverLabels, overlay) {
    const byId = new Map();
    for (const label of serverLabels)if (label?.id && label?.name) byId.set(label.id, {
        id: label.id,
        name: label.name
    });
    for (const label of overlay.applied)byId.set(label.id, label);
    for (const id of overlay.removedIds)byId.delete(id);
    return Array.from(byId.values());
}
function $b65ece114130bf2f$export$23b48700db7e8e0a() {
    $b65ece114130bf2f$var$overlaysByContentId.clear();
    $b65ece114130bf2f$var$emit();
}
function $b65ece114130bf2f$export$5940070e4f73739c(contentId) {
    return (0, $cozmU.useSyncExternalStore)($b65ece114130bf2f$var$subscribe, ()=>$b65ece114130bf2f$var$getOverlay(contentId), // Server snapshot: no optimistic overlay exists during SSR.
    ()=>$b65ece114130bf2f$var$EMPTY_OVERLAY);
}
module.exports["optimisticallyApplyManagedLabel"] = $b65ece114130bf2f$export$9b54af9aebcc60dd;
module.exports["optimisticallyRemoveManagedLabel"] = $b65ece114130bf2f$export$20e81981b62d0763;
module.exports["rollbackApplyManagedLabel"] = $b65ece114130bf2f$export$3d3b7bba0896e547;
module.exports["rollbackRemoveManagedLabel"] = $b65ece114130bf2f$export$4b06ca8750380d71;
module.exports["reconcileManagedLabelsOverlay"] = $b65ece114130bf2f$export$82eebc89860bc67a;
module.exports["mergeManagedLabelsWithOverlay"] = $b65ece114130bf2f$export$9fac4e0451bfa81d;
module.exports["useManagedLabelsOverlay"] = $b65ece114130bf2f$export$5940070e4f73739c;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("1xzIe", function(module, exports) {
/**
 * @generated SignedSource<<3d131e1dcc35166fd57ac33b8b83b173>>
 * @relayHash 707494bac283c331e553bcfd3a25e7de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 682f6507e1445d3c96118feee5ef54e0e89d6fa8de14aca779a4fa02b20c13d0
const $e4c12f84c9729495$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalLabelsAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalLabelsCloudId"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeExternalLabels"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": {
                            "direction": "ASCENDING",
                            "sortField": "LABELLING_CREATIONDATE"
                        }
                    }
                ],
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "label"
                            },
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "prefix"
                            }
                        ]
                    }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
            }
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "externalLabelsCloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "externalLabelsAri"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FooterLabelsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v7 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "useExternalLabels_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "externalLabelsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FooterLabelsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "ConfluenceExternalLabel",
                            "kind": "LinkedField",
                            "name": "confluence_externalLabels",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "kind"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "707494bac283c331e553bcfd3a25e7de",
            "id": "682f6507e1445d3c96118feee5ef54e0e89d6fa8de14aca779a4fa02b20c13d0",
            "metadata": {},
            "name": "FooterLabelsQuery",
            "operationKind": "query",
            "text": "query FooterLabelsQuery($contentId:ID!,$includeExternalLabels:Boolean=false,$externalLabelsCloudId:ID!,$externalLabelsAri:ID!){singleContent(id:$contentId){id,type,operations{operation,targetType},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){nodes{id,label,name,prefix}}},...useExternalLabels_query_2n00s0@include(if:$includeExternalLabels)}fragment useExternalLabels_query_2n00s0 on Query{confluence_externalLabels(cloudId:$externalLabelsCloudId,id:$externalLabelsAri){id,kind,name}}"
        }
    };
}();
$e4c12f84c9729495$var$node.hash = "838528cff8e59b95b5de3462fd73232a";
var $e4c12f84c9729495$export$2e2bcd8739ae039 = $e4c12f84c9729495$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $IOtUu = parcelRequire("IOtUu");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $kh0hi = parcelRequire("kh0hi");


var $EzOZy = parcelRequire("EzOZy");


var $krxYo = parcelRequire("krxYo");


var $lpNn5 = parcelRequire("lpNn5");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");


var $8aF6s = parcelRequire("8aF6s");


var $hysf6 = parcelRequire("hysf6");


var $4vaoM = parcelRequire("4vaoM");


var $jkwMx = parcelRequire("jkwMx");


var $5pMqB = parcelRequire("5pMqB");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $jMyy4 = parcelRequire("jMyy4");

const $0edb016a56df6289$export$ef7716fb21e26e68 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const labelsShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_LABELS_SHORTCUT)
    });
    // Managed (external) labels ride on this query via the `useExternalLabels_query`
    // fragment; Relay dedups against the warmed store, so no extra request.
    const externalLabelsVariables = (0, $jkwMx.useExternalLabelsFragmentVariables)(contentId);
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $e4c12f84c9729495$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            includeExternalLabels: externalLabelsVariables.includeExternalLabels,
            externalLabelsCloudId: externalLabelsVariables.cloudId,
            externalLabelsAri: externalLabelsVariables.id
        },
        __callerPackage__: "labels-footer"
    });
    const intl = (0, $kSwu1.useIntl)();
    // Read from the aliased fragment; empty list when the gate is off (re-checked
    // inline at the render sites).
    const externalLabels = (0, $jkwMx.useExternalLabelsFragment)(data?.externalLabelsFragment);
    // Shared optimistic overlay so an apply/remove from another surface reflects here
    // immediately.
    const managedOverlay = (0, $5pMqB.useManagedLabelsOverlay)(contentId);
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    const content = data?.singleContent;
    const hasEditPermissions = Boolean(content?.operations?.find((item)=>item?.operation === 'update' && item?.targetType === content?.type));
    const labels = content?.labels?.nodes?.filter((node)=>node?.name !== 'favourite' || node?.prefix !== 'my') || [];
    const maxVisibleLabels = (0, $6mKj3.expValEquals)('confluence_footer_reactions_redesign', 'isEnabled', true) ? 5 : 2;
    // Managed labels render first (matching the dialog / details panel order),
    // with the optimistic overlay merged in. Gated inline so nothing leaks when off.
    const managedLabels = (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? (0, $5pMqB.mergeManagedLabelsWithOverlay)(externalLabels, managedOverlay) : [];
    // Unified list (managed first) so the "max N + overflow" rule spans both kinds.
    const footerTags = [
        ...managedLabels.map((label)=>({
                key: `managed-${label.id}`,
                name: label.name,
                isManaged: true
            })),
        ...labels.map((label)=>({
                key: String(label?.id),
                name: label?.name,
                isManaged: false
            }))
    ];
    if (footerTags.length === 0) {
        if (!hasEditPermissions) // don't show anything if user doesn't have edit permissions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                hasEditPermissions: hasEditPermissions,
                labelsCount: labels.length
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0edb016a56df6289$var$i18n.addLabelTooltip) : undefined,
            shortcut: labelsShortcutStrings,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $0edb016a56df6289$var$addLabelsButton,
            onClick: ()=>showModal((0, $4vaoM.EditLabelDialogLoader), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: 'labelsFooter'
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0edb016a56df6289$var$i18n.addLabels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                labelsCount: labels.length,
                hasEditPermissions: hasEditPermissions
            }
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0edb016a56df6289$var$i18n.manageLabelsTooltip) : undefined,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $0edb016a56df6289$var$labelsContainer,
        onClick: ()=>{
            showDetailsPanel({
                highlightLabels: true
            });
        }
    }, footerTags.slice(0, maxVisibleLabels).map((tag)=>tag.name ? tag.isManaged ? // Blue tag + globe icon. No `migration_fallback`: the Lozenge
        // fallback drops `elemBefore` (the icon).
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: tag.key,
            text: tag.name,
            color: "blue",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
                label: intl.formatMessage($0edb016a56df6289$var$i18n.managedLabelIconLabel),
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            hasMargin: false,
            isRemovable: false
        }) : (0, $6mKj3.expValEquals)('confluence_footer_reactions_redesign', 'isEnabled', true) ? // The new chip layout: `Tag`'s lozenge fallback renders a bordered,
        // unfilled chip; render a plain filled chip instead to match the
        // solid-fill design.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            key: tag.key,
            xcss: $0edb016a56df6289$var$newFooterLabelChip
        }, tag.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: tag.key,
            text: tag.name,
            migration_fallback: "lozenge",
            hasMargin: false,
            isRemovable: false
        }) : null), footerTags.length > maxVisibleLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: (0, $6mKj3.expValEquals)('confluence_footer_reactions_redesign', 'isEnabled', true) ? $0edb016a56df6289$var$additionalLabelsNew : $0edb016a56df6289$var$additionalLabels
    }, "+", footerTags.length - maxVisibleLabels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        attributes: {
            labelsCount: footerTags.length
        }
    }));
};
const $0edb016a56df6289$var$labelsContainer = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $0edb016a56df6289$var$additionalLabels = (0, $buxP3.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    paddingInline: 'space.050'
});
// New layout only: matches the solid-fill chips' regular weight, rather than the previous tags'
// bold "+N" — kept separate from `additionalLabels` above so that weight is unaffected.
const $0edb016a56df6289$var$additionalLabelsNew = (0, $buxP3.xcss)({
    font: 'font.body.small',
    paddingInline: 'space.050'
});
// Solid grey fill, no border — see the comment where this is used, above, for why it bypasses `Tag`.
const $0edb016a56df6289$var$newFooterLabelChip = (0, $buxP3.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    paddingInline: 'space.100',
    paddingBlock: 'space.025',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral',
    color: 'color.text',
    font: 'font.body.small'
});
const $0edb016a56df6289$var$addLabelsButton = (0, $buxP3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    paddingInline: 'space.150',
    borderRadius: 'radius.small',
    color: 'color.text.subtle',
    font: 'font.body',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $0edb016a56df6289$var$i18n = (0, $kSwu1.defineMessages)({
    addLabels: {
        id: "labels-footer.addLabels",
        defaultMessage: "Add labels"
    },
    addLabelTooltip: {
        id: "labels-footer.addLabel-tooltip",
        defaultMessage: "Add label"
    },
    manageLabelsTooltip: {
        id: "labels-footer.manageLabels-tooltip",
        defaultMessage: "Manage labels"
    },
    managedLabelIconLabel: {
        id: "labels-footer.managed-label-icon-label",
        defaultMessage: "Managed label"
    }
});
module.exports["FooterLabels"] = $0edb016a56df6289$export$ef7716fb21e26e68;

});


//# sourceMappingURL=labels-footer.1d85515a.js.map
